<template>
  <vjs-modal :name="item_qc_modal"
             :title="`Create ${getItemLabel(true)}`"
             :show-icon="false"
             sticky-header>
    <episode-creation-form v-if="isEpisode" :preselected-feed="preselectedFeed" />
    <item-creation-form v-else :preselected-feed="preselectedFeed" :preselected-storage-asset="preselectedStorageAsset" />
  </vjs-modal>
</template>

<script>
import ItemCreationForm from 'VueComponents/ItemCreation/Form';
import EpisodeCreationForm from 'VueComponents/EpisodeCreation/Form';

export default {
  components: {
    ItemCreationForm,
    EpisodeCreationForm,
  },
  props: {
    preselectedStorageAsset: {
      type: Object,
      required: false,
      default: null,
    },
    preselectedFeed: {
      type: Object,
      required: false,
      default: null,
    },
    isEpisode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  beforeMount() {
    this.item_qc_modal = 'item-create-modal';
  },
};
</script>
